import m from 'mithril'
import { css } from '@emotion/css'
import { colors, font, space } from '../styles/theme.js'

const stepperBar = css`
  display: flex;
  align-items: center;
  margin-bottom: ${space.xl};
  gap: 0;
`

const stepItem = css`
  display: flex;
  align-items: center;
  gap: ${space.sm};
  cursor: default;
  padding: ${space.xs} ${space.md};
  border-radius: 6px;
  transition: background 0.15s;
  font-size: ${font.size.sm};
`

const stepClickable = css`
  cursor: pointer;
  &:hover { background: ${colors.bgSidebar}; }
`

const stepNumber = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: ${font.size.xs};
  font-weight: ${font.weight.semibold};
`

const stepConnector = css`
  flex: 0 0 24px;
  height: 1px;
  background: ${colors.border};
`

/**
 * WizardStepper component
 *
 * attrs:
 *   steps: [{ label }]
 *   currentStep: number (0-indexed)
 *   onStep: (stepIndex) => void
 */
export function WizardStepper() {
  return {
    view(vnode) {
      const { steps, currentStep, onStep } = vnode.attrs
      const children = []

      for (let i = 0; i < steps.length; i++) {
        const step = steps[i]
        const isCurrent = i === currentStep

        if (i > 0) {
          children.push(m('div', { class: stepConnector, key: `c-${i}` }))
        }

        const numberStyle = isCurrent
          ? `background: ${colors.brand}; color: white;`
          : `background: ${colors.border}; color: ${colors.textMuted};`

        const labelStyle = isCurrent
          ? `color: ${colors.text}; font-weight: ${font.weight.semibold};`
          : `color: ${colors.textMuted};`

        children.push(m('div', {
          key: `s-${i}`,
          class: `${stepItem} ${stepClickable}`,
          onclick: () => onStep(i),
        }, [
          m('div', { class: stepNumber, style: numberStyle }, i + 1),
          m('span', { style: labelStyle }, step.label),
        ]))
      }

      return m('div', { class: stepperBar }, children)
    },
  }
}
